import { path } from 'ramda'
import { refreshToken } from '../api/authApi'

export const refreshTokenMiddleware = ({ dispatch, getState }) => next => action => {
    // Only worry about expiring token for async actions
    if (typeof action === 'function') {
        const { auth } = getState()

        if (auth && auth.token) {
            const expiresIn = path(['token', 'experes_in'], auth)
            const time = path(['token', 'time'], auth)

            const isTokenExpired = +new Date() > time + expiresIn * 1000

            if (isTokenExpired) {
                // Make sure we are not already refreshing the token
                if (!auth.freshTokenPromise) {
                    return refreshToken(dispatch).then(() => next(action))
                } else {
                    return auth.freshTokenPromise.then(() => next(action))
                }
            }
        }
    }
    return next(action)
}



// WEBPACK FOOTER //
// ./src/middlewares/refreshTokenMiddleware.js